import React from "react"

interface AvatarBackProps {
  className?: string
  alt?: string
}
const AvatarBack: React.FC<AvatarBackProps> = ({ alt = "", className }) => (
  <svg
    className={className}
    fill="none"
    height={490}
    viewBox="0 0 680 490"
    width={680}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <title>{alt}</title>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="a"
        x1={444.95}
        x2={329.027}
        y1={528.316}
        y2={-18.223}
      >
        <stop stopColor="#581fe6" />
        <stop offset={1} stopColor="#ff6800" />
      </linearGradient>

      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={115.938}
        id="b"
        width={115.938}
        x={159.066}
        y={77.218}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-9} dy={12} />
        <feGaussianBlur stdDeviation={20} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_617_11105"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_617_11105"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={44}
        id="g"
        width={116}
        x={72.5}
        y={88}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_617_11105"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_617_11105"
          result="shape"
        />
      </filter>
    </defs>
    <path
      d="M236.107 115.747c-4.935-5.43-13.375-5.845-18.479-.574-29.537 30.503-49.704 69.028-57.92 110.973a221.54 221.54 0 0 0 17.054 137.073c20.149 42.712 53.406 77.841 94.885 100.223 37.568 20.272 80.085 29.119 122.364 25.62 7.307-.605 12.338-7.381 11.285-14.636-1.051-7.246-7.775-12.221-15.077-11.677-36.68 2.735-73.501-5.079-106.089-22.664-36.493-19.692-65.752-50.598-83.479-88.177a194.9 194.9 0 0 1-15.005-120.596c7.131-36.405 24.494-69.882 49.91-96.543 5.04-5.287 5.463-13.617.551-19.022"
      fill="url(#a)"
    />
    <circle
      cx={226.033}
      cy={123.187}
      fill="var(--bgCardColorDarker)"
      r={17.964}
      transform="rotate(165 226.033 123.187)"
    />
    <circle
      cx={226.033}
      cy={123.187}
      r={16.714}
      stroke="url(#c)"
      strokeWidth={2.5}
      transform="rotate(165 226.033 123.187)"
    />
    <circle
      cx={225.935}
      cy={123.355}
      fill="#ff6800"
      r={12.189}
      stroke="url(#d)"
      strokeWidth={2.5}
      transform="rotate(165 225.935 123.355)"
    />
    <path
      d="M509 .25h113.615c7.042 0 12.75 5.708 12.75 12.75v79.627c0 7.041-5.708 12.75-12.75 12.75H509c-7.042 0-12.75-5.708-12.75-12.75V13c0-7.042 5.708-12.75 12.75-12.75Z"
      fill="var(--bgCardColorDarker)"
      strokeWidth={2.5}
    />
    <circle cx={511.051} cy={11.273} fill="#e75252" r={2.832} />
    <circle cx={522.379} cy={11.273} fill="#fbd85b" r={2.832} />
    <circle cx={533.711} cy={11.273} fill="#80d869" r={2.832} />
    <rect
      fill="#d9d9d9"
      height={8.025}
      rx={4.012}
      width={76}
      x={508.219}
      y={24.019}
    />
    <rect
      fill="#d9d9d9"
      height={8.025}
      rx={4.012}
      width={32.099}
      x={508.219}
      y={42.9}
    />
    <rect
      fill="var(--gil-colors-fg)"
      height={8.025}
      rx={4.012}
      width={51.453}
      x={540}
      y={75.944}
    />
    <rect
      fill="var(--bgCardColorDarker)"
      height={105.127}
      rx={12.75}
      strokeWidth={2.5}
      width={139.115}
      x={1.25}
      y={215.25}
    />
    <circle cx={16.051} cy={226.273} fill="#e75252" r={2.832} />
    <circle cx={27.379} cy={226.273} fill="#fbd85b" r={2.832} />
    <circle cx={38.711} cy={226.273} fill="#80d869" r={2.832} />
    <rect
      fill="#50aee3"
      height={7.956}
      rx={3.978}
      transform="rotate(-90 84.332 313.184)"
      width={54.63}
      x={84.332}
      y={313.184}
    />
    <rect
      fill="#5bb943"
      height={8.025}
      rx={4.012}
      transform="rotate(-90 40.84 312.929)"
      width={32.099}
      x={40.84}
      y={312.929}
    />
    <rect
      fill="var(--gil-colors-fg)"
      height={7.956}
      rx={3.978}
      transform="rotate(-90 19.094 313.184)"
      width={17.503}
      x={19.094}
      y={313.184}
    />
    <rect
      fill="var(--gil-colors-fg)"
      height={7.956}
      rx={3.978}
      transform="rotate(-90 62.586 313.184)"
      width={17.503}
      x={62.586}
      y={313.184}
    />
    <rect
      fill="var(--gil-colors-fg)"
      height={7.956}
      rx={3.978}
      transform="rotate(-90 106.078 313.184)"
      width={17.503}
      x={106.078}
      y={313.184}
    />
    <path
      d="m139 267.5.753.053a32 32 0 0 0 16.587-3.312l360.893-180.85A32 32 0 0 1 531.569 80H533"
      stroke="#0c8ce9"
      strokeWidth={2}
    />
    <circle
      cx={142}
      cy={268}
      fill="var(--bgCardColorDarker)"
      r={5.5}
      stroke="#0c8ce9"
    />
    <path d="M598.5 70.5v18h-64v-18z" stroke="#2c81ff" />
    <path
      d="M536.5 68.5h-4v4h4zM600.5 68.5h-4v4h4zM600.5 86.5h-4v4h4zM536.5 86.5h-4v4h4z"
      fill="var(--bgCardColorDarker)"
      stroke="#2c81ff"
    />
    <circle
      cx={531}
      cy={79}
      fill="var(--bgCardColor)"
      r={5.5}
      stroke="#0c8ce9"
    />
    <path d="M531 76v6M534 79h-6" stroke="#0c8ce9" />
    <rect
      fill="var(--bgCardColorDarker)"
      height={40}
      rx={8}
      width={112}
      x={74.5}
      y={89}
    />
    <rect
      height={39}
      rx={7.5}
      stroke="var(--gil-colors-border)"
      width={111}
      x={75}
      y={89.5}
    />
    <rect
      fill="var(--gil-colors-fg)"
      height={12}
      rx={6}
      width={52}
      x={90.5}
      y={103}
    />
    <path
      d="m155.5 106.5 5 5 5-5"
      stroke="#344054"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
    />
    <rect
      fill="var(--gil-colors-bg-inverted)"
      height={18}
      rx={5}
      width={92}
      x={84.5}
      y={138}
    />
    <rect
      fill="var(--gil-colors-fg-inverted)"
      height={10}
      rx={5}
      width={52}
      x={92.5}
      y={142}
    />
    <rect fill="#bbb" height={10} rx={5} width={20} x={148.5} y={142} />
    <path d="m130.5 133-6 6h12z" fill="var(--gil-colors-bg-inverted)" />
  </svg>
)

export default AvatarBack
